"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aiRoutes = void 0;
const aiActions_openapi_1 = require("./aiActions.openapi");
exports.aiRoutes = [
    {
        name: 'ai.model-list',
        path: '/models/:provider',
        method: 'GET'
    },
    {
        name: 'ai.image_model-list',
        path: '/image-models',
        method: 'GET'
    },
    {
        name: 'ai.image_model-list-by-pipeline',
        path: '/image-models/pipeline',
        method: 'GET'
    },
    {
        name: 'ai.generate-image',
        path: '/image/generate',
        method: 'POST',
        plugins: {
            openapi: aiActions_openapi_1.aiOpenApiDocs['ai.generate-image']
        }
    },
    {
        name: 'ai.chat',
        path: '/chat',
        method: 'POST',
        plugins: {
            openapi: aiActions_openapi_1.aiOpenApiDocs['ai.chat']
        }
    },
    {
        name: 'ai.cancel-request',
        path: '/cancel-request',
        method: 'POST',
        plugins: {
            openapi: aiActions_openapi_1.aiOpenApiDocs['ai.cancel-request']
        }
    },
    {
        name: 'ai.active-requests',
        path: '/active-requests',
        method: 'GET'
    },
    {
        name: 'ai.extract-fields',
        path: '/extract-fields',
        method: 'POST',
        plugins: {
            openapi: aiActions_openapi_1.aiOpenApiDocs['ai.extract-fields']
        }
    },
    {
        name: 'ai.upload-file',
        path: '/upload-file',
        method: 'POST',
        plugins: {
            openapi: aiActions_openapi_1.aiOpenApiDocs['ai.upload-file']
        }
    },
    {
        name: 'ai.assist',
        path: '/assist',
        method: 'POST',
        plugins: {
            openapi: aiActions_openapi_1.aiOpenApiDocs['ai.assist']
        }
    },
    {
        name: 'ai.triggerSearch',
        path: '/trigger-search',
        method: 'GET'
    },
    {
        name: 'ai.create-slot-data',
        path: '/slot-data',
        method: 'POST',
        plugins: {
            openapi: aiActions_openapi_1.aiOpenApiDocs['ai.create-slot-data']
        }
    },
    {
        name: 'ai.get-slot-data',
        path: '/slot-data',
        method: 'GET'
    },
    {
        name: 'ai.delete-slot-data',
        path: '/slot-data/:id',
        method: 'DELETE'
    },
    {
        name: 'ai.performance-metrics',
        path: '/performance/metrics',
        method: 'GET'
    },
    {
        name: 'ai.performance-stats',
        path: '/performance/stats',
        method: 'GET'
    },
    {
        name: 'ai.reset-performance-metrics',
        path: '/performance/reset',
        method: 'POST'
    },
    {
        name: 'ai.scrape-web-for-onboarding-step',
        path: '/scrape-onboarding',
        method: 'POST',
        plugins: {
            openapi: aiActions_openapi_1.aiOpenApiDocs['ai.scrape-web-for-onboarding-step']
        }
    },
    {
        name: 'ai.sitemap',
        path: '/sitemap',
        method: 'POST'
    }
];
